module.exports = __webpack_public_path__ + "static_pc/img/10.15d3228d.jpg";